export const getLimitCountriesParameter = (
  limitResultsToExistingCountry: boolean,
  jobLocationCountry: string,
) => {
  const shouldLimitCountries =
    limitResultsToExistingCountry && Boolean(jobLocationCountry);

  const countries = shouldLimitCountries
    ? {
        only: [jobLocationCountry?.toUpperCase()],
      }
    : undefined;

  return countries;
};
